export default "__VITE_ASSET__CBsJ5BOV__"